import React, { Component } from 'react';
import { Button, Row, Col } from 'react-bootstrap';

class CashbackKey extends Component {

    render() {
        const { cbResult, result, KeyValue, isMobile } = this.props;
        return (
            <>
                <Row className="text-center mt-3">
                    <Col>
                        <Button block variant="warning" id="Cashback" name="Cashback" disabled={((parseInt(cbResult) * 1) === 0 || cbResult === '' || parseInt(result) < parseInt(cbResult)) ? true : false} onClick={() => this.props.onClick()}>
                            {isMobile ? KeyValue.Mobile.Cashback : KeyValue.Desktop.Cashback}
                        </Button>
                    </Col>
                </Row>
            </>
        );
    }
}


export default CashbackKey;
